import { ProductPackagingRequirements } from '../../../../../../products/product-details/constants/product-options';

export type ProductOption = { name?: string; value?: string };

// Pulls the productPackagingRequirements value out of a product's options (undefined if absent).
export const getPackagingRequirement = (productOptions: ProductOption[] | undefined): string | undefined =>
  productOptions?.find((option) => option.name === ProductPackagingRequirements)?.value;
